import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'DoubleSquareCheckBox',
  props: {
    selected: { type: Boolean },
    hasActive: { type: Boolean }
  },
  emits: ['onClick'],
  setup(__props: any, { emit }) {





const handleOnClick = () => {
  emit('onClick');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["body", { selected: __props.selected }]),
    onClick: handleOnClick
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["inner", { 'has-active': __props.hasActive, selected: __props.selected }])
    }, null, 2)
  ], 2))
}
}

})